import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const PostAdPage = lazy(() => import('../pages/post-ad/page'));
const AdSuccessPage = lazy(() => import('../pages/ad-success/page'));
const SignInPage = lazy(() => import('../pages/signin/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const JobsPage = lazy(() => import('../pages/category/jobs/page'));
const HousesForSalePage = lazy(() => import('../pages/category/real-estate/houses-for-sale/page'));
const CarsPage = lazy(() => import('../pages/category/vehicles/cars/page'));
const PhonesPage = lazy(() => import('../pages/category/electronics/phones/page'));
const ClothingPage = lazy(() => import('../pages/category/fashion/clothing/page'));
const FurniturePage = lazy(() => import('../pages/category/furniture/living-room/page'));
const ServicesPage = lazy(() => import('../pages/category/services/home-services/page'));
const AdminLogin = lazy(() => import('../pages/admin-login/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/categories',
    element: <CategoriesPage />
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />
  },
  {
    path: '/help',
    element: <HelpPage />
  },
  {
    path: '/post-ad',
    element: <PostAdPage />
  },
  {
    path: '/ad-success',
    element: <AdSuccessPage />
  },
  {
    path: '/signin',
    element: <SignInPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/category/jobs',
    element: <JobsPage />
  },
  {
    path: '/category/real-estate/houses-for-sale',
    element: <HousesForSalePage />
  },
  {
    path: '/category/vehicles/cars',
    element: <CarsPage />
  },
  {
    path: '/category/electronics/phones',
    element: <PhonesPage />
  },
  {
    path: '/category/fashion/clothing',
    element: <ClothingPage />
  },
  {
    path: '/category/furniture/living-room',
    element: <FurniturePage />
  },
  {
    path: '/category/services/home-services',
    element: <ServicesPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
